module.exports = __webpack_public_path__ + "img/accounts-transfer-ok.7c092651.png";